<template>
  <div class="shipments-per-day-chart">
    <wrld-box :headerTitle="$t(title)">

      <template v-slot:boxContent>
        <apexchart ref="dayChart" type="bar" :height="height" :options="options" :series="series"></apexchart>
      </template>
    </wrld-box>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { createWidgetMixin } from 'vue-instantsearch'
import { connectRefinementList } from 'instantsearch.js/es/connectors/'
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'EntityPerDayChart',
  components: {
    'apexchart': VueApexCharts
  },
  mixins: [
    createWidgetMixin({ connector: connectRefinementList })
  ],
  props: {
    mainDateFilter: String,
    title: String,
    entity: String,
    height: {
      type: Number,
      default: 400
    }
  },
  data () {
    return {
      // options: {
      //   chart: {
      //     id: 'total-' + this.entity + '-chart',
      //     // defaultLocale: 'en',
      //     locales: [{
      //       "name": "en",
      //       "options": {
      //         "months": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      //         "shortMonths": ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
      //         "days": ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      //         "shortDays": ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      //         "toolbar": {
      //           "exportToSVG": "Download SVG",
      //           "exportToPNG": "Download PNG",
      //           "menu": "Menu",
      //           "selection": "Selection",
      //           "selectionZoom": "Selection Zoom",
      //           "zoomIn": "Zoom In",
      //           "zoomOut": "Zoom Out",
      //           "pan": "Panning",
      //           "reset": "Reset Zoom"
      //         }
      //       }
      //     },
      //     {
      //       "name": "cs",
      //       "options": {
      //         "months": ["Leden", "Únor", "Březen", "Duben", "Květen", "Červen", "Červenec", "Srpen", "Září", "Říjen", "Listopad", "Prosinec"],
      //         "shortMonths": ["Led", "Úno", "Bře", "Dub", "Kvě", "Čvn", "Čvc", "Srp", "Zář", "Říj", "Lis", "Pro"],
      //         "days": ["Neděle", "Pondělí", "Úterý", "Středa", "Čtvrtek", "Pátek", "Sobota"],
      //         "shortDays": ["Ne", "Po", "Út", "St", "Čt", "Pá", "So"],
      //         "toolbar": {
      //           "exportToSVG": "Stáhnout SVG",
      //           "exportToPNG": "Stáhnout PNG",
      //           "exportToCSV": "Stáhnout CSV",
      //           "menu": "Menu",
      //           "selection": "Vybrat",
      //           "selectionZoom": "Zoom: Vybrat",
      //           "zoomIn": "Zoom: Přiblížit",
      //           "zoomOut": "Zoom: Oddálit",
      //           "pan": "Přesouvat",
      //           "reset": "Resetovat"
      //         }
      //       }
      //     }
      //   ],
      //   zoom: {
      //     enabled: true,
      //     type: 'x',
      //     autoScaleYaxis: true
      //     }
      //   },
      //   dataLabels: {
      //     enabled: false
      //   },
      //   xaxis: {
      //     type: 'datetime'
      //   },
      //   annotations: {
      //     xaxis: [{
      //       x: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).getTime(),
      //       borderColor: '#999',
      //       yAxisIndex: 0,
      //       label: {
      //         show: true,
      //         text: this.$t('reports.today'),
      //         style: {
      //           color: '#fff',
      //           background: '#000'
      //         }
      //       }
      //     }]
      //   }
      // }
    }
  },
  mounted () {
    this.$refs.dayChart.chart.setLocale(this.$i18n.locale)
  },
  beforeUpdate () {
    this.$refs.dayChart.chart.setLocale(this.$i18n.locale)
  },
  computed: {
    ...mapState(['generalApp']),
    options () {
      let options = {
          chart: {
          id: 'total-' + this.entity + '-chart',
        zoom: {
          enabled: true,
          type: 'x',
          autoScaleYaxis: true
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          type: 'datetime'
        },
        annotations: {
          xaxis: [{
            x: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).getTime(),
            borderColor: '#999',
            yAxisIndex: 0,
            label: {
              show: true,
              text: this.$t('reports.today'),
              style: {
                color: '#fff',
                background: '#000'
              }
            }
          }]
        }
      }
      return options
    },
    results () {
      let results = []
      if (this.state !== null) {
        results = this.state.items
      }

      if (this.selectedDateRange.length > 0) {
        if (this.selectedDateRange.length === 1) {
          if (this.selectedDateRange[0].operator === '>=') {
            results = results.filter(date => {
              return (date.value >= this.selectedDateRange[0].value)
            })
          } else {
            results = results.filter(date => {
              return (date.value <= this.selectedDateRange[0].value)
            })
          }
        }
        if (this.selectedDateRange.length === 2) {
          results = results.filter(date => {
            return (date.value >= this.selectedDateRange[0].value && date.value <= this.selectedDateRange[1].value)
          })
        }
      }

      results.sort(function (a, b) {
        a = a.value
        b = b.value
        return a < b ? -1 : a > b ? 1 : 0
      })

      return results
    },
    selectedDateRange () {
      let selectedDateRange = []
      this.generalApp.allSelectedFilters.forEach(filter => {
        if (filter.filterObj.attribute === this.mainDateFilter) {
          selectedDateRange = filter.filterObj.values
        }
      })
      return selectedDateRange
    },
    widgetParams () {
      return {
        limit: 1000,
        attribute: this.mainDateFilter
      }
    },
    series () {
      var dates = []
      const recordLength = this.results.length
      for (let i = 0; i < recordLength; i++) {
        const date = this.results[i].value * 1000
        const count = this.results[i].count
        const innerArr = [date, count]
        dates.push(innerArr)
      }
      return [{
        name: this.$t('reports.total') + ' ' + this.entity,
        data: dates
      }]
    }
  }
}
</script>
